module.exports = __webpack_public_path__ + "img/img3.23494438.svg";